import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/employee-redux";
import { Container, Loader } from "semantic-ui-react";

import { MHPTreatmentReport } from "@teamprevent/common/mentalHealthPractitionerTreatment/components/MHPTreatmentReport";
import { getMHPTreatmentReportModel, MHPTreatmentReportModel, MHP_TREATMENT_REPORT_KEY } from "@teamprevent/common/mentalHealthPractitionerTreatment/models";
import { ConsultationDetails } from "@teamprevent/common/model";

import { ApplicationState } from "../../applicationState";
import { mhpTreatmentApi } from "../mhpTreatmentApi";
import { loadMHPTreatmentReportByViewTaskId } from "../actions";

export const MHPTreatmentReportDetail: React.FunctionComponent = () => {

    const dispatch = useDispatch();

    const [report, setReport] = React.useState<MHPTreatmentReportModel>(null);
    const [consultationDetails, setConsultationDetails] = React.useState<ConsultationDetails>(null);

    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const viewReportTaskId = useSelector((state: ApplicationState) => state.router.params?.viewReportTaskId);
    const questionnaire = useSelector((state: ApplicationState) => state.questionnaires[MHP_TREATMENT_REPORT_KEY]);

    React.useEffect(() => {
        if (ohCaseId && viewReportTaskId) {
            loadQuestionnaire();
        }
    }, [ohCaseId, viewReportTaskId]);

    React.useEffect(() => {
        setReport(getMHPTreatmentReportModel(questionnaire));
    }, [questionnaire]);

    const loadQuestionnaire = () => {
        (async () => {
            dispatch(loadMHPTreatmentReportByViewTaskId(ohCaseId, viewReportTaskId, MHP_TREATMENT_REPORT_KEY));

            const consultationDetailsModel = await mhpTreatmentApi.getConsultationDetailsByViewTaskId(ohCaseId, viewReportTaskId);
            setConsultationDetails(consultationDetailsModel);
        })();
    };

    if (!report || !consultationDetails) {
        return (
            <Container className="referral-report">
                <Loader active />
            </Container>
        );
    }

    return (
        <MHPTreatmentReport
            readonly={true}
            customerId={null}
            employeeRecord={null}
            ohCase={null}
            task={null}
            report={report}
            isFromAdmin={false}
            isReportPreview={false}
            loadReport={() => null}
            consultationAndReferralDetails={consultationDetails}
        />
    );
};
